export default "__VITE_ASSET__sHnqXAaZ__"